'use client';

import { c as _c } from "react/compiler-runtime";
import { trackContact } from '@/lib/tracking/events';
import { WhatsappLogo } from '@phosphor-icons/react';
import { useLocale } from 'next-intl';
import { Button } from '@/components/storefront/ui/button';
import { useStoreContact } from '@/lib/storefront/store-contact';
import { buildWhatsAppUrl, productEnquiryMessage } from '@/lib/storefront/whatsapp-link';

/**
 * "Ask about this product" — opens WhatsApp to the store's number with the
 * product name and its URL already in the message, so the merchant knows what
 * the customer is looking at without asking.
 *
 * Renders nothing when the store has no usable WhatsApp number: a dead link to
 * wa.me is worse than no button.
 */
export function WhatsAppAskButton(t0) {
  const $ = _c(9);
  const {
    productName,
    productUrl
  } = t0;
  const {
    whatsappPhone
  } = useStoreContact();
  const locale = useLocale();
  const isRTL = locale === "ar";
  if (!whatsappPhone) {
    return null;
  }
  let t1;
  if ($[0] !== isRTL || $[1] !== productName || $[2] !== productUrl || $[3] !== whatsappPhone) {
    t1 = function handleClick() {
      const url = productUrl ?? (typeof window !== "undefined" ? window.location.href : "");
      trackContact("whatsapp");
      window.open(buildWhatsAppUrl(whatsappPhone, productEnquiryMessage({
        productName,
        productUrl: url,
        isRTL
      })), "_blank", "noopener,noreferrer");
    };
    $[0] = isRTL;
    $[1] = productName;
    $[2] = productUrl;
    $[3] = whatsappPhone;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleClick = t1;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <WhatsappLogo weight="fill" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = isRTL ? "\u0647\u0644 \u0644\u062F\u064A\u0643 \u0633\u0624\u0627\u0644 \u0639\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0646\u062A\u062C\u061F" : "Ask about this product";
  let t4;
  if ($[6] !== handleClick || $[7] !== t3) {
    t4 = <Button type="button" onClick={handleClick} variant="outline" color="default" size="lg" fullWidth={true} leftIcon={t2}>{t3}</Button>;
    $[6] = handleClick;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}